import HeaderComponent from "src/Components/Header";
import FooterComponent from "src/Components/Footer";
import CheckoutLayout from "src/Layouts/Checkout";

const CheckoutPage = () => {
  return (
    <>
      <div className="min-h-full">
        <HeaderComponent />
        <main>
          <div className="mx-auto max-w-7xl py-6 sm:px-6 lg:px-8">
            <CheckoutLayout />
          </div>
        </main>
        <FooterComponent />
      </div>
    </>
  );
};

export default CheckoutPage;
